<template>
  <div class="aboutUs content">
    <div class="banner-sub">
      <img :src="backgroundImg.topImg" alt="">
    </div>
    <div class="wrap">
      <div class="title">
        <h2>集百优简介</h2>
        <span></span>
      </div>

      <!-- 公司介绍 start -->
      <div class="profile">
        <div v-html="about.company"></div>
      </div>
      <!-- 公司介绍 end -->

      <!-- 公司文化 start -->
      <div class="culture">
        <div class="bg"><img :src="about.culture.img" alt=""></div>
        <!-- <div class="bg"><img src="~@/assets/img/culture_bg.png" alt=""></div> -->
        <div class="culture-head">
          <div class="title">
            <h2>公司文化</h2>
            <span></span>
          </div>
        </div>
        <div class="culture-box">
          <div class="item">
            <div class="img-box"><img src="~@/assets/img/icon_culture_01.png" alt=""></div>
            <p>诚信</p>
          </div>
          <div class="item">
            <div class="img-box"><img src="~@/assets/img/icon_culture_02.png" alt=""></div>
            <p>务实</p>
          </div>
          <div class="item">
            <div class="img-box"><img src="~@/assets/img/icon_culture_03.png" alt=""></div>
            <p>创新</p>
          </div>
          <div class="item">
            <div class="img-box"><img src="~@/assets/img/icon_culture_04.png" alt=""></div>
            <p>团结</p>
          </div>
        </div>
      </div>
      <!-- 公司文化 end -->

      <!-- 发展历程 start -->
      <div class="history">
        <div class="history-box">
          <div class="title his-left">
            <h2>发展历程</h2>
            <span></span>
          </div>
          <div class="his-list scroll">
            <div class="his-box">
              <div :id="'scroll_into_' + item.id" class="item" v-for="(item, idx) in historyList" :key="idx"
                :class="{ 'active': idx === activeIndex }">
                <div :id="'t_scroll_into_' + item.id" class="t_scroll_into"></div>
                <h2 class="txt01">
                  <span>{{item.year}}</span>
                  <span v-if="item.month !== ''">-{{ item.month}}</span>
                </h2>
                <p class="txt02">{{ item.title}}</p>
                <div class="detail-box">
                  <p class="txt03" v-html="item.content"></p>
                </div>
              </div>
              <div class="item">
                <h2 class="txt01"><span></span><span></span></h2>
              </div>
            </div>
          </div>
        </div>
        <!-- 历程时间轴 start -->
        <div class="his-date">
          <div class="item" @click="jump(item.id, idx)" v-for="(item, idx) in historyList" :key="idx"
            :class="{ 'active': idx === activeIndex }">
            <span>{{item.year}}</span>
            <span v-if="item.month !== ''">-{{ item.month}}</span>
          </div>
        </div>
        <!-- 历程时间轴 end -->
      </div>
      <!-- 发展历程 end -->
    </div>
    <div class="honor-box">
      <div class="wrap">
        <div class="title">
          <h2>资质与荣誉</h2><span></span>
        </div>
        <div class="honor">
          <div class="honor-01"><img src="~@/assets/img/honor_item.png" alt=""></div>
          <template v-for="(item, idx) in honorList">
            <div class="honor-item" :key="idx" v-if="idx < 4">
              <div class="img-box">
                <img :src="item.img" alt="">
              </div>
              <div class="honor-txt-box">
                <h2 class="txt-h2">{{ item.typeName }}</h2>
                <p class="txt-p">{{ item.title }}</p>
              </div>
            </div>
          </template>
          <!-- <div class="honor-item">
            <div class="img-box">
              <img src="~@/assets/img/honor_item.png" alt="">
            </div>
            <div class="honor-txt-box">
              <h2 class="txt-h2">软件著作权</h2>
              <p class="txt-p">集百优自动极光限界测量仪</p>
            </div>
          </div> -->
        </div>
        <div class="swiper-honor">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <template v-for="(item, idx) in honorList">
                <div class="swiper-slide honor-item" :key="idx" v-if="idx > 3">
                  <div class="img-box">
                    <img :src="item.img" alt="">
                  </div>
                  <div class="honor-txt-box">
                    <h2 class="txt-h2">{{ item.typeName }}</h2>
                    <p class="txt-p">{{ item.title }}</p>
                  </div>
                </div>
              </template>
              <!-- <div class="swiper-slide honor-item">
                <div class="img-box">
                  <img src="~@/assets/img/honor_item.png" alt="">
                </div>
                <div class="honor-txt-box">
                  <h2 class="txt-h2">软件著作权2</h2>
                  <p class="txt-p">集百优自动极光限界测量仪</p>
                </div>
              </div> -->

            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination"></div>
            <!-- Add Arrows -->
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from 'vue-bootstrap-pagination'
import { ApiWebAboutHisList, ApiWebAboutHonorList, ApiWebAboutCompanyData, ApiWebBackdropImg } from '../api/aboutus'
export default {
  name: 'about',
  data () {
    return {
      activeIndex: 0,
      // 发展历程list
      historyList: [],
      // 所有荣誉资质list
      honorList: [],
      // 关于集百优
      about: {
        company: '',
        culture: {
          content: '',
          img: ''
        }
      },
      // 顶部和底部背景图片
      backgroundImg: {
        topImg: '',
        bottomImg: '',
        companyImg: ''
      }
    }
  },
  components: {
    pagination
  },
  created() {
    this.getHistoryList()
    this.getHonorList()
    this.initAbout()
    this.topbackground()
  },
  methods: {
    /**
   * 点击年份
   */
    jump(id, idx) {
      this.activeIndex = idx
      document.getElementById("t_scroll_into_" + id).scrollIntoView();
    }, 
    /**
     * 发展历程
     */
    getHistoryList() {
      ApiWebAboutHisList().then(({ data }) => {
        if (data && data.status === 0) {
          this.historyList = data.data.list
        }
      })
    },
    /**
     * 荣誉资质
     */
    getHonorList() {
      ApiWebAboutHonorList().then(({ data }) => {
        if (data && data.status === 0) {
          this.honorList = data.data.list
          this.$nextTick(() => {
            var swiper = new Swiper('.swiper-container', { // eslint-disable-line no-unused-vars
              // pagination: '.swiper-pagination',
              nextButton: '.swiper-button-next',
              prevButton: '.swiper-button-prev',
              slidesPerView: 3,
              centeredSlides: true,
              loopFillGroupWithBlank: true,
              spaceBetween: 15,
              loop: true
            })
          })
        }
      })
    },
    /**
     * 关于集百优
     */
    initAbout () {
      ApiWebAboutCompanyData().then(({data}) => {
        if (data && data.status === 0) {
          this.about = data.data
        }
      })
    },
    /**
     * 获取banner图
     */
    topbackground () {
      ApiWebBackdropImg().then(({data}) => {
        if (data && data.status === 0) {
          this.backgroundImg = data.data
        }
      })
    }
  }
}
</script>

<style scoped lang="less">

  @import '../assets/style/index.less';
  .swiper-slide {
    overflow: hidden;
  }
</style>
<style  lang="less">


.aboutUs .profile {
  padding: 0 24px;
  p{
    color: #666666;
    font-size: 20px;
    line-height: 36px;
    font-weight: 400;
    margin: 0;
    padding: 0;
  }
}
.detail-box .txt03{
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 36px;
}
.t_scroll_into{
  width: 100%;
  height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutus.vue